import { useTranslation } from "react-i18next";
import Box from "/app/src/components/generic/components/box";
import HeroButton from "/app/src/components/HeroUi/Button";
import { App, Order } from "/app/src/models";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { appService } from "/app/src/services";
import { buildParams } from "/app/src/helpers";
import { useCallback } from "react";

/**
 * OrderDetails component displays detailed information for a specific order.
 *
 * @param {{ order: Order }} props - The component props.
 * @param {Order} props.order - The order object to display details for.
 * @returns {JSX.Element} The rendered component displaying order details.
 */
export default function OrderDetails({ order }: { order: Order }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: orderBuilderAppId } = useQuery({
    queryKey: ["app", "Order Builder"],
    queryFn: () => {
      return appService.getAll(
        buildParams({
          name: "Order Builder",
        }),
      );
    },
    initialData: { apps: [] },
    select: (data: { apps: App[] }) => {
      return data.apps.find((app) => app.name === "Order Builder")?.id || null;
    },
  });

  const navigateToOrderBuilder = useCallback(() => {
    if (orderBuilderAppId) {
      navigate(`/apps/${orderBuilderAppId}`);
    }
  }, [navigate, orderBuilderAppId]);

  return (
    <Box>
      <div className="flex justify-between items-center">
        <h2 className="text-[18px] mb-0">{order?.name}</h2>
        <HeroButton
          onClick={navigateToOrderBuilder}
          color="primary"
          variant="bordered"
        >
          {t("translation:return_to_order_builder")}
        </HeroButton>
      </div>
    </Box>
  );
}
